import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import JumboDemoCard from "@jumbo/components/JumboDemoCard/JumboDemoCard";


import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Grid,
  Typography,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  CircularProgress,
} from "@mui/material";

import { GetWebinarUsersListApi } from "backendServices/ApiCalls";
import { useTranslation } from "react-i18next";


const Transition = React.forwardRef((props, ref) => {
  return <Slide direction="down" ref={ref} {...props} />;
});

const WebinarUserTable = () => {

    const [userList, setUserList] = useState([]);
    const [ isLoading,setIsLoading] = useState([]);
      const { t } = useTranslation();

        const pendingStyle = {
    padding: "10px 20px",
    border: "none",
    borderRadius: "6px",
    color: "#fff",
    fontWeight: "bold",
    cursor: "pointer",
    backgroundColor: "#facc15", // yellow
    marginRight: "10px"
  };

  const approvedStyle = {
    padding: "10px 20px",
    border: "none",
    borderRadius: "6px",
    color: "#fff",
    fontWeight: "bold",
    cursor: "pointer",
    backgroundColor: "#22c55e" // green
  };


const  columns = [
      {
        field: "index",
        headerName: "#",
        width: 80,
      },

       {
        field: "first_name",
        headerName: "First Name",
        width: 200,
        editable: true,
        groupable: false,
      },

      {
        field: "email",
        headerName: "Email",
        width: 200,
        editable: true,
        groupable: false,
      },

        {
        field: "customer_id",
        headerName: "Customer ID",
        width: 200,
        editable: true,
        groupable: false,
      },
     
      {
        field: "",
        headerName: "Type",
        width: 200,
        editable: true,
        groupable: false,
         renderCell: (params) => {
            if (params?.row?.plan_id?.includes("Essential")) {
                if (params?.row?.isDownSell) {
                    return "Down Sell"
                }else{
                    return "Normal Sell"
                }
            }else{
                return "Up Sell"
            }
         }
      },
       {
        field: "createdat",
        headerName: "CreatedAt",
        width: 200,
        editable: true,
        groupable: false,
      },

       {
        field: "status",
        headerName: "Status",
        width: 200,
        editable: true,
        groupable: false,
         renderCell: (params) => {
            if (params?.row?.password) {
                return <button style={approvedStyle}>Approved</button>
            }else{ 
               return <button style={pendingStyle}>Pending</button>
            }
             
         }
      },

    ];
  const gridDesign = {
    "& .MuiDataGrid-toolbarContainer": {
      "& .MuiButton-text": {
        fontSize: "13px !important",
      },
      "& .MuiBadge-badge": {
        backgroundColor: "#074682",
        // color: '#074682',
      },
      "& .MuiBadge-badge": {
        backgroundColor: "#074682",
      },
      "& .MuiInput-root": {
        borderRadius: 2,
        paddingLeft: 2,
        overflow: "hidden",
      },
    },
  };
  
useEffect(() => {
GetUsersList()
}, [])

 const GetUsersList = () => {
    setIsLoading(true);
    GetWebinarUsersListApi(
      (response) => {
        const processedData = response?.data?.users?.map((row, index) => ({
          ...row,
          index: index + 1,
        }));
        setUserList(processedData)

        // console.log("processedData: ",processedData)
        setIsLoading(false);
      },
      (error) => {
           setIsLoading(false);
        console.log(error?.response?.data);
      }
    );
  };



  
  



  return (
    <Grid
      container
      fullWidth
      sm={12}
      xs={12}
      p={2}
      alignItems="center"
      justifyContent="center"
    >
      <Grid item sm={12} xs={12}>
        <JumboDemoCard
          title={t("pages.title.userlist")}
          wrapperSx={{ backgroundColor: "background.paper", pt: 0 }}
        >
          {/* {alertData.show && (
            <SweetAlert alertData={alertData} setalertData={setalertData} />
          )} */}
      

          <Box sx={{ height: 500, width: 1 }}>
            <DataGrid
              initialState={{
                pagination: { paginationModel: { pageSize: 6 } },
              }}
              rows={userList}
              getRowId={(row) => row.id}
              columns={columns}
              slots={{ toolbar: GridToolbar }}
              sx={gridDesign}
              pageSizeOptions={[6, 12, 18, 24, 30]}
              loading={isLoading}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </Box>
        
    
        </JumboDemoCard>
      </Grid>

  
    </Grid>
  );
};

export default WebinarUserTable;